module.exports = __webpack_public_path__ + "static/jupiter-tequesta-logo-d01db9e39003a85396b9b506f07d78a5.svg";